import { TopLogo, Colors } from './email-advanced-settings.component';

export const emptyTopLogo: TopLogo = {
  showLogo: null,
  customImageUrl: null,
  width: null,
  align: null,
  topPadding: null,
  bottomPadding: null,
  collapsed: null,
  link: null,
  defaultSourceUrl: null,
};

export const emptyColors: Colors = {
  textColor: '#5f6368',
  titleColor: '#22292f',
  subtitleColor: '#999999',
  linkColor: '#057EC1',
  footerTextColor: '#858585',
  textBackground: '#FFFFFF',
  pageBackground: '#EEEEEE',
  collapsed: true,
};
